<div id="toggle-visible-password" [ngClass]="{'inside-input': insideInput}">
  <i *ngIf="hasText && isHidden" class="far fa-eye" aria-hidden="true" (click)="onClick()"></i>
  <i *ngIf="hasText && !isHidden" class="fa fa-eye-slash" aria-hidden="true" (click)="onClick()"></i>
</div>